import React from "react"

import PropTypes from "prop-types"

const StepContent = ({name, index, isLastStep, isResponsive}) => (
    <>
        <div className="stepper-item-graph">
            <div aria-hidden="true" className={`stepper-item-graph-line left${index === 0 ? " hidden" : ""}`}></div>
            <div aria-hidden="true" className="stepper-item-graph-circle">
                {index + 1}
            </div>
            <div aria-hidden="true" className={`stepper-item-graph-line right${isLastStep ? " hidden" : ""}`}></div>
        </div>
        {!isResponsive && <div className="stepper-item-label">{name}</div>}
    </>
)

StepContent.propTypes = {
    index: PropTypes.number.isRequired,
    isLastStep: PropTypes.bool.isRequired,
    isResponsive: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
}

export default StepContent
